import { render, staticRenderFns } from "./SpecimenInfo.vue?vue&type=template&id=04362e20&scoped=true"
import script from "./SpecimenInfo.vue?vue&type=script&lang=js"
export * from "./SpecimenInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecimenInfo.vue?vue&type=style&index=0&id=04362e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04362e20",
  null
  
)

export default component.exports